// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import WishlistMessages from '@shopping-funnel/components/messages';
import HeaderIconWithBadge from '@header/scripts/components/HeaderIconWithBadge.jsx';
import WishlistErrorLayer from '@wishlist/components/WishlistErrorLayer.jsx';

export default function WishlistNavigationHeader({wishlistUrl, wishlistCount, deviceType, texts, enabled}) {
    const [currentWishlistCount, setCurrentWishlistCount] = useState(wishlistCount);
    const landmarkClickData = {navi: `tn\\wishlist\\\\${deviceType}\\`};

    const handleClick = () => {
        Landmark.sendLandmark({landmark: 'userinterface', ...landmarkClickData});
    };
    const handleDeletion = (messageData) => {
        setCurrentWishlistCount(messageData.currentItemsInWishlist);
    };
    const handleAddition = (messageData) => {
        setCurrentWishlistCount((previousCountState) => previousCountState + messageData.amountAdded);
    };

    useEffect(() => {
        const deletionSubscription = MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_DELETED, handleDeletion);
        const additionSubscription = MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_ADDED, handleAddition);
        return () => {
            MessageBroker.unsubscribe(deletionSubscription);
            MessageBroker.unsubscribe(additionSubscription);
        };
    }, [currentWishlistCount]);

    if (!enabled) {
        return <div className="header__icon-box"></div>;
    }

    return (
        <>
            <a
                className="header__icon-box"
                onClick={handleClick}
                href={wishlistUrl}
                title={texts.ho_meta_nav_wunschliste}
            >
                <HeaderIconWithBadge count={currentWishlistCount} iconName="heart" />
            </a>
            <WishlistErrorLayer texts={texts} />
        </>
    );
}
